module.exports = __webpack_public_path__ + "img/40e1e1b.png";